module.exports = "\r\n<app-sidenav></app-sidenav>\r\n\r\n"